import axios from '../../axios';
import {
  BILLING_MASTER_ITEMS_LOADED, BILLING_OPERATORS_LOADED,
  BILLING_OPERATOR_ITEMS_LOADED, BILLING_REVIEW_ITEMS_LOADED,
  BILLING_ACTIVITY_LOGS_LOADED,
} from '../actionTypes/billing';

// API base paths
const M = '/api/v1/billing/master-items';
const OP = '/api/v1/billing/operators';
const RQ = '/api/v1/billing/review-queue';
const AL = '/api/v1/billing/activity-logs';
const OI = (operatorId) => `/api/v1/billing/operators/${operatorId}/items`;
const OIT = (id) => `/api/v1/billing/operator-items/${id}`;

// ── Master Sheet ──────────────────────────────────────────────────────────────

export const fetchMasterItems = (params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(M, { params });
    dispatch({ type: BILLING_MASTER_ITEMS_LOADED, payload: res.data });
  } catch (e) { }
};

export const createMasterItem = (data, callback) => async () => {
  try {
    const res = await axios.post(M, data);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const updateMasterItem = (id, data, callback) => async () => {
  try {
    const res = await axios.patch(`${M}/${id}`, data);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const approveMasterItem = (id, callback) => async () => {
  try {
    const res = await axios.post(`${M}/${id}/approve`);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const deactivateMasterItem = (id, callback) => async () => {
  try {
    const res = await axios.delete(`${M}/${id}`);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const exportMasterItems = (callback) => async () => {
  try {
    const res = await axios.get(`${M}/export`);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const previewMasterImport = (rows, callback) => async () => {
  try {
    const res = await axios.post(`${M}/preview-import`, { rows });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const applyMasterImport = (rows, filename, callback) => async () => {
  try {
    const res = await axios.post(`${M}/apply-import`, { rows, filename });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

// ── Operators ─────────────────────────────────────────────────────────────────

export const fetchOperators = (params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(`${OP}`, { params });
    dispatch({ type: BILLING_OPERATORS_LOADED, payload: res.data });
  } catch (e) { }
};

// ── Operator Overrides ────────────────────────────────────────────────────────

export const fetchOperatorItems = (operatorId, params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(OI(operatorId), { params });
    dispatch({ type: BILLING_OPERATOR_ITEMS_LOADED, payload: res.data });
  } catch (e) { }
};

export const createOperatorItem = (operatorId, data, callback) => async () => {
  try {
    const res = await axios.post(OI(operatorId), data);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const updateOperatorItem = (id, data, callback) => async () => {
  try {
    const res = await axios.patch(OIT(id), data);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const exportOperatorItems = (operatorId, callback) => async () => {
  try {
    const res = await axios.get(`${OI(operatorId)}/export`);
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const previewOperatorImport = (operatorId, rows, callback) => async () => {
  try {
    const res = await axios.post(`${OI(operatorId)}/preview-import`, { rows });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const applyOperatorImport = (operatorId, rows, filename, callback) => async () => {
  try {
    const res = await axios.post(`${OI(operatorId)}/apply-import`, { rows, filename });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

// ── Review Queue ──────────────────────────────────────────────────────────────

export const fetchReviewItems = (params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(RQ, { params });
    dispatch({ type: BILLING_REVIEW_ITEMS_LOADED, payload: res.data });
  } catch (e) { }
};

export const exportReviewItems = (params = {}, callback) => async () => {
  try {
    const res = await axios.get(`${RQ}/export`, { params });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const importReviewItems = (rows, callback) => async () => {
  try {
    const res = await axios.post(`${RQ}/import`, { rows });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const resolveReviewItem = (id, resolvedMasterData, resolvedOperatorData, callback) => async () => {
  try {
    const res = await axios.post(`${RQ}/${id}/resolve`, { resolvedMasterData, resolvedOperatorData });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

export const dismissReviewItem = (id, dismissNote, callback) => async () => {
  try {
    const res = await axios.post(`${RQ}/${id}/dismiss`, { dismissNote });
    callback(null, res.data);
  } catch (e) { callback(e); }
};

// ── Activity Logs ─────────────────────────────────────────────────────────────

export const fetchActivityLogs = (params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(AL, { params });
    dispatch({ type: BILLING_ACTIVITY_LOGS_LOADED, payload: res.data });
  } catch (e) { }
};